<div *ngIf="data.type === 'unSubs'">
	<h5 style="color: red;">Delete Confirmation</h5>
	<div mat-dialog-content>
		<p class="mt-3 mb-5">Are you sure, Do you want to unsubscribe from all events?</p>
	</div>
	<div mat-dialog-actions>
		<button type="button" class="ml-auto mr-3" color="warn" (click)="onYes()" mat-raised-button [mat-dialog-close]="data.animal">
			Yes
		</button>
		<button type="button" class="mr-3" mat-raised-button [mat-dialog-close]="data.animal" cdkFocusInitial>
			No
		</button>
	</div>
</div>

<div *ngIf="data.type === 'subs'">
	<h5 style="color: red;">Note</h5>
	<div mat-dialog-content>
		<p class="mt-3 mb-3">You will receive an email to your registered email address. Please click the <span style="text-decoration: underline;color: blue;">confim subscription</span> link in that email to start receiving notifications.<br>
			You will not be able to remove this subscription until you confirm.</p>
	</div>
	<div mat-dialog-actions>
			<button type="button" class="ml-auto mr-3" mat-raised-button [mat-dialog-close]="data.animal" cdkFocusInitial>
				Ok
			</button>
	</div>
</div>
